import React from "react";
import { FormattedMessage } from "react-intl";
import { NewFADVLoginForm } from "./NewFADVLoginForm";
import { navigateToApplication, navigateToDashboard } from "../../redux/helpers/navigators";

export default function SuccessPrompt() {

  const handleNavigateToDashboard = () => {
    navigateToDashboard();
  }

  const handleSubmit = () => {
    navigateToApplication();
  }

  return (
    <NewFADVLoginForm
      onSubmit={handleSubmit}
      showErrors={true}
      requiredFields={[]}
      headerContent={<FormattedMessage id="login.firstTimeSuccess" defaultMessage="Success!" description="Success message for first time login" />}
      submitButtonText={<FormattedMessage id="login.firstTimeAutoLaunch" defaultMessage="Continue" description="Button text to continue to application after first time login" />}
      secondaryButtonText={<FormattedMessage id="login.firstTimeContinueToDashboard" defaultMessage="Add Account" description="Button text to navigate to dashboard for adding accounts" />}
      secondaryButtonHandler={handleNavigateToDashboard}
      secondaryButtonId="goToDashboard"
    >
      <FormattedMessage
        id="login.firstTimeBlurb"
        defaultMessage="You may continue directly into your secure account or add another First Advantage account in your Account Dashboard."
        description="Instructions for first time login users on next steps"
      />
    </NewFADVLoginForm>
  )
}
